import script from "./NotificationDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationDropdown.vue?vue&type=script&setup=true&lang=js"

import "./NotificationDropdown.vue?vue&type=style&index=0&id=49df2fd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49df2fd0"]])

export default __exports__